<template>
  <div class="container">
    <map-of-united-states />

    <fragrances-by-state-leaderboards />
  </div>
</template>

<script>
  import MapOfUnitedStates from './top-selling-fragrances/map-of-united-states';
  import FragrancesByStateLeaderboards from './top-selling-fragrances/leaderboards'

  export default {
    components: {
      MapOfUnitedStates,
      FragrancesByStateLeaderboards
    }
  }
</script>
